import type { ComponentProps } from "react";

export default function CertificateIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6 12.3333H10M4.66667 9.99992H11.3333M3.33333 1.33325H12.6667C13.403 1.33325 14 1.99653 14 2.81473V13.1851C14 14.0033 13.403 14.6666 12.6667 14.6666H3.33333C2.59695 14.6666 2 14.0033 2 13.1851V2.81473C2 1.99653 2.59695 1.33325 3.33333 1.33325ZM7.9984 4.14121C7.53189 3.62179 6.75394 3.48206 6.16943 3.9577C5.58492 4.43334 5.50263 5.22858 5.96165 5.79112C6.42067 6.35366 7.9984 7.66658 7.9984 7.66658C7.9984 7.66658 9.57614 6.35366 10.0352 5.79112C10.4942 5.22858 10.4219 4.42833 9.82738 3.9577C9.23282 3.48706 8.46492 3.62179 7.9984 4.14121Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
